import {
  Board,
  BoardHeader,
  BoardSearchDetail,
  BoardSearchResult,
  CalendarBox,
  CalendarIcon,
  ColSpan0,
  ColSpan1,
  ColTitle,
  CustomDatePicker,
  DateContainer,
  DeleteButton,
  GraySearchButton,
  RangePicker,
  RowSpan,
  Span1,
  selectStyle, ColSpan4, ColSpan2, mainColor
} from "../../assets/GlobalStyles";
import Select from "react-select";
import ko from "date-fns/locale/ko";
import {HorizontalRule} from "../../components/common/Common";
import React, {useCallback, useEffect, useState} from "react";
import {
  getLastDay,
  getLastMonth,
  getLastNinetyDay,
  getLastThirtyDay,
  getLastWeekDay,
  getThisMonth,
  getToDay
} from "../../common/DateUtils";
import Table from "../../components/table";
import {
  deleteCustomReportsAxios,
  retrieveCommonReportsDetail, retrieveCommonReportsDetailByAdverId,
  retrieveCustomReportsDetail
} from "../../services/reports/ReportsAxios";
import {useAtom, useAtomValue, useSetAtom} from "jotai";
import {tokenResultAtom} from "../login/entity/Common";
import {useLocation, useNavigate} from "react-router-dom";
import {dateFormat, decimalFormat, moneyToFixedFormat, numberToFixedFormat} from "../../common/StringUtils";
import {reportsInfoAtom} from "../../components/aside/entity";
import {deviceType, productType, targetingType} from "../dash_board/entity/Common";
import {
  deleteCustomReportsAdminAxios,
  retrieveCommonReportsAdminDetail,
  retrieveCommonReportsAdminDetailByAdverId,
  retrieveCustomReportsAdminDetail
} from "../../services/reports/ReportsAdminAxios";
import {confirmAlert} from "react-confirm-alert";
import moment from "moment";
import {light} from "../../assets/theme";
import {css} from "styled-components";
import {
  summaryReducer,
  summaryReportReducer
} from "../dash_board/entity/Campaign";
import {lockedRows} from "./ReportsCampaign";
import {lockedReportRows, rowDetailsDataAtom, tableIdAtom} from "./entity/common";
import TableDetail from "../../components/table/TableDetail";
import HoverInventorys from "../../components/common/HoverInventorys";

function weekNumberByMonth(dateFormat) {
  const inputDate = new Date(dateFormat);

  // 인풋의 년, 월
  let year = inputDate.getFullYear();
  let month = inputDate.getMonth() + 1;

  // 목요일 기준 주차 구하기
  const weekNumberByThurFnc = (paramDate) => {

    const year = paramDate.getFullYear();
    const month = paramDate.getMonth();
    const date = paramDate.getDate();

    // 인풋한 달의 첫 날과 마지막 날의 요일
    const firstDate = new Date(year, month, 1);
    const lastDate = new Date(year, month+1, 0);
    const firstDayOfWeek = firstDate.getDay() === 0 ? 7 : firstDate.getDay();
    const lastDayOfweek = lastDate.getDay();

    // 인풋한 달의 마지막 일
    const lastDay = lastDate.getDate();

    // 첫 날의 요일이 금, 토, 일요일 이라면 true
    const firstWeekCheck = firstDayOfWeek === 5 || firstDayOfWeek === 6 || firstDayOfWeek === 7;
    // 마지막 날의 요일이 월, 화, 수라면 true
    const lastWeekCheck = lastDayOfweek === 1 || lastDayOfweek === 2 || lastDayOfweek === 3;

    // 해당 달이 총 몇주까지 있는지
    const lastWeekNo = Math.ceil((firstDayOfWeek - 1 + lastDay) / 7);

    // 날짜 기준으로 몇주차 인지
    let weekNo = Math.ceil((firstDayOfWeek - 1 + date) / 7);

    // 인풋한 날짜가 첫 주에 있고 첫 날이 월, 화, 수로 시작한다면 'prev'(전달 마지막 주)
    if(weekNo === 1 && firstWeekCheck) weekNo = 'prev';
    // 인풋한 날짜가 마지막 주에 있고 마지막 날이 월, 화, 수로 끝난다면 'next'(다음달 첫 주)
    else if(weekNo === lastWeekNo && lastWeekCheck) weekNo = 'next';
    // 인풋한 날짜의 첫 주는 아니지만 첫날이 월, 화 수로 시작하면 -1;
    else if(firstWeekCheck) weekNo = weekNo -1;

    return weekNo;
  };

  // 목요일 기준의 주차
  let weekNo = weekNumberByThurFnc(inputDate);

  // 이전달의 마지막 주차일 떄
  if(weekNo === 'prev') {
    // 이전 달의 마지막날
    const afterDate = new Date(year, month-1, 0);
    year = month === 1 ? year - 1 : year;
    month = month === 1 ? 12 : month - 1;
    weekNo = weekNumberByThurFnc(afterDate);
  }
  // 다음달의 첫 주차일 때
  if(weekNo === 'next') {
    year = month === 12 ? year + 1 : year;
    month = month === 12 ? 1 : month + 1;
    weekNo = 1;
  }

  return {year, month, weekNo};
}


const adverColumn = [
  {
    name: 'userId',
    header:'',
    defaultVisible: false
  },
  {
    name: 'adverName',
    header: '광고주명',
    textAlign: 'center',
    render: (props) => {
      return <span>{props.value}</span>
    },
    flex: 1
  },
  {
    name: 'exposureCount',
    header: '노출수',
    textAlign: 'center',
    type: 'number',
    sortable: true,
    render: ({value}) => {
      return <span>{decimalFormat(value)}</span>
    },
    flex: 1
  },
  {
    name: 'costAmount',
    header: '비용',
    textAlign: 'center',
    type: 'number',
    sortable: true,
    render: ({value}) => {
      return <span className={'won'} style={{color: '#c55'}}>{decimalFormat(value)}</span>
    },
    flex: 1
  },
  {
    name: 'eCpm',
    header: 'CPV',
    textAlign: 'center',
    type: 'number',
    sortable: false,
    render: (props) => {
      const ecpm = (props.data.costAmount / props.data.exposureCount) * 1000
      return <span className={'won'} style={{color: '#5c5'}}>{!isNaN(ecpm) ? moneyToFixedFormat(ecpm) : 0}</span>
    },
    flex: 1
  }
]


const campaignColumn = [
  {
    name: 'campaignName',
    header: '캠페인명',
    textAlign: 'center',
    render: (props) => {
      return <span>{props.value}</span>
    },
    flex: 1
  },
  {
    name: 'allowInventorys',
    header: '연결 지면',
    textAlign: 'center',
    width: 100,
    type: 'number',
    sortable: true,
    render: ({ value }) => <HoverInventorys ids={value} />,
    flex: 0.5
  },
  {
    name: 'exposureCount',
    header: '노출수',
    textAlign: 'center',
    type: 'number',
    sortable: true,
    render: ({value}) => {
      return <span>{decimalFormat(value)}</span>
    },
    flex: 1
  },
  {
    name: 'costAmount',
    header: '비용',
    textAlign: 'center',
    type: 'number',
    sortable: true,
    render: ({value}) => {
      return <span className={'won'} style={{color: '#c55'}}>{decimalFormat(value)}</span>
    },
    flex: 1
  },
  {
    name: 'eCpm',
    header: 'CPV',
    textAlign: 'center',
    type: 'number',
    sortable: false,
    render: (props) => {
      const ecpm = (props.data.costAmount / props.data.exposureCount) * 1000
      return <span className={'won'} style={{color: '#5c5'}}>{!isNaN(ecpm) ? moneyToFixedFormat(ecpm) : 0}</span>
    },
    flex: 1
  }
]


export default function ReportsAdver() {
  const mainColor = light.color.topicColor;
  const [searchCondition, setSearchCondition] = useState({
    pageSize: 100,
    currentPage: 1,
    searchStartDate: getThisMonth().startDay,
    searchEndDate: getToDay(),
    productType: null,
    deviceType: null
  })
  const [dateActive,setDateActive] = useState('thisMonth')
  const [dateRange, setDateRange] = useState([ new Date(getThisMonth().startDay), new Date(getToDay())]);
  const [startDate, endDate] = dateRange;
  const tokenResult = useAtomValue(tokenResultAtom);
  const [adverData, setAdverData] = useState([]);
  const [rowDetailData, setRowDetailData] = useAtom(rowDetailsDataAtom)
  const [reportSettingInfo, setReportSettingInfo] = useState({});
  const navigate = useNavigate();
  const [reportsInfo, setReportsInfo] = useAtom(reportsInfoAtom)
  const tableId = useAtomValue(tableIdAtom)

  useEffect(() => {
    if(reportsInfo.id === null) return navigate('/board/reports')
    if(tokenResult?.role !== "NORMAL") {
      retrieveCommonReportsAdminDetail(tokenResult?.id, searchCondition, 'adver').then(response => {
        if(response){
          setAdverData(response?.pagingCommonResponse.content)
          setReportSettingInfo(response?.adminSetting)
        }
      })
    } else {
      retrieveCommonReportsDetail(tokenResult?.id, searchCondition, 'adver').then(response => {
        if(response) {
          setAdverData(response.pagingCommonResponse.content)
          setReportSettingInfo(response.userSetting)
        }
      })
    }
    return () => {
      setDateActive('thisMonth')
      setDateRange([ new Date(getThisMonth().startDay), new Date(getToDay())])
      setSearchCondition({
        pageSize: 100,
        currentPage: 1,
        searchStartDate: getThisMonth().startDay,
        searchEndDate: getToDay(),
        productType: null,
        deviceType:  null
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenResult, reportsInfo.id]);

  /**
   * 날짜 직접 변경
   */
  const handleChangeDate = (date) => {
    setDateRange(date)
    if(date[1] !== null){
      setSearchCondition({
        ...searchCondition,
        searchStartDate: moment(date[0]).format('YYYY-MM-DD'),
        searchEndDate: moment(date[1]).format('YYYY-MM-DD'),
      })
    }
  }
  /**
   * 날짜 레인지 선택
   * @param rangeType
   */
  const handleRangeDate = (rangeType) => {
    setDateActive(rangeType)
    if (rangeType === 'thisMonth') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getThisMonth().startDay,
        searchEndDate: getThisMonth().endDay
      })
      setDateRange([new Date(getThisMonth().startDay), new Date(getThisMonth().endDay)])
    } else if (rangeType === 'lastMonth') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getLastMonth().startDay,
        searchEndDate: getLastMonth().endDay
      })
      setDateRange([new Date(getLastMonth().startDay), new Date(getLastMonth().endDay)])
    } else if (rangeType === 'today') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getToDay(),
        searchEndDate: getToDay()
      })
      setDateRange([new Date(), new Date()])
    } else if (rangeType === 'lastDay') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getLastDay(),
        searchEndDate: getLastDay()
      })
      setDateRange([new Date(getLastDay()), new Date(getLastDay())])
    } else if (rangeType === 'lastWeekDay') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getLastWeekDay().startDay,
        searchEndDate: getLastWeekDay().endDay
      })
      setDateRange([new Date(getLastWeekDay().startDay), new Date(getLastWeekDay().endDay)])
    } else if (rangeType === 'lastThirtyDay') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getLastThirtyDay().startDay,
        searchEndDate: getLastThirtyDay().endDay
      })
      setDateRange([new Date(getLastThirtyDay().startDay), new Date(getLastThirtyDay().endDay)])
    } else if (rangeType === 'lastNinetyDay') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getLastNinetyDay().startDay,
        searchEndDate: getLastNinetyDay().endDay
      })
      setDateRange([new Date(getLastNinetyDay().startDay), new Date(getLastNinetyDay().endDay)])
    }
    //call 때려
  }
  /**
   * 광고상품
   * @param event
   */
  const handleChangeProduct = (event) => {
    setSearchCondition({
      ...searchCondition,
      productType: event.value
    })
  }
  /**
   * 디바이스 서치
   * @param event
   */
  const handleChangeDevice = (event) => {
    console.log(event.value)
    setSearchCondition({
      ...searchCondition,
      deviceType: event.value
    })
  }
  /**
   * 검색
   */
  const handleSearchReports = () => {
    if(tokenResult.role !== "NORMAL") {
      retrieveCommonReportsAdminDetail(tokenResult.id, searchCondition, 'adver').then(response => {
        setAdverData(response?.pagingCommonResponse.content)
      })
    }else {
      retrieveCommonReportsDetail(tokenResult.id, searchCondition, 'adver').then(response => {
        setAdverData(response?.pagingCommonResponse.content)
      })
    }
  }
  const fetchData = () => {
    if(tokenResult?.role !== "NORMAL") {
      retrieveCommonReportsAdminDetailByAdverId(tokenResult?.id, searchCondition, 'campaign', tableId).then(response => {
        const data = response?.pagingCommonResponse.content;
        setRowDetailData(data)
      })
    }else {
      retrieveCommonReportsDetailByAdverId(tokenResult.id, searchCondition, 'campaign', tableId).then(response => {
        const data = response?.pagingCommonResponse.content;
        setRowDetailData(data)
      })
    }
  }

  useEffect(() => {
    if(tableId !== null) {
      fetchData()
    }
  }, [tableId,searchCondition]);
  /**
   * 상세 데이타 페칭
   * @param event
   */
  const handleFetchDetailData = useCallback(fetchData,[])
  const rowExpandHeight = ({ data }) => {
    if(data?.campaignCount !== 0) {
      if(data.campaignCount < 6) {
        return 112+(data.campaignCount*55)
      } else return 442
    } else return 300;
  }
  return(<>
    <Board>
      <BoardHeader>{`광고주별 보고서`}</BoardHeader>
        <BoardSearchDetail>
              <RowSpan style={{justifyContent: 'flex-start'}}>
                <ColSpan1>
                  <ColTitle><span>광고 상품</span></ColTitle>
                  <Select options={productType}
                          defaultValue={productType[0]}
                          value={productType.find(item => item.value === searchCondition.productType)}
                          onChange={handleChangeProduct}
                          styles={selectStyle}
                          isSearchable={false}
                  />
                  {/*<Select styles={selectStyle} defaultValue={productType[0]} options={productType} onChange={handleChangeProduct} value={productType.find(item => item.value === searchCondition.productType)}/>*/}
                </ColSpan1>
                <ColSpan1>
                  <ColTitle><span>디바이스</span></ColTitle>
                  <Select options={deviceType}
                          defaultValue={deviceType[0]}
                          value={deviceType.find(item => item.value === searchCondition.deviceType)}
                          onChange={handleChangeDevice}
                          styles={selectStyle}
                          isSearchable={false}
                  />
                  {/*<div style={{width: '100px'}}>*/}
                  {/*  <Select styles={selectStyle} defaultValue={deviceType[0]} options={deviceType} onChange={handleChangeDevice} value={deviceType.find(item => item.value === searchCondition.deviceType)}/>*/}
                  {/*</div>*/}
                </ColSpan1>
              </RowSpan>
            <RowSpan style={{justifyContent: 'flex-start'}}>
              <ColSpan1>
              <ColTitle><span>기간</span></ColTitle>
                <div style={{width:'100%'}}>
                      <DateContainer>
                        <CalendarBox>
                          <CalendarIcon/>
                        </CalendarBox>
                        <CustomDatePicker
                          selectsRange={true}
                          startDate={startDate}
                          endDate={endDate}
                          onChange={(date) => handleChangeDate(date)}
                          dateFormat="yyyy-MM-dd"
                          maxDate={new Date()}
                          locale={ko}
                          isClearable={false}
                          monthsShown={2}
                          openToDate={endDate}
                        />
                      </DateContainer>
                </div>
              </ColSpan1>
              <ColSpan2>
                <div>
                  <RangePicker>
                    <div onClick={() => handleRangeDate('thisMonth')} style={dateActive==='thisMonth'?{color:mainColor, fontWeight:"bold"}:null}>이번달</div>
                    <HorizontalRule style={{margin: "0 10px"}}/>
                    <div onClick={() => handleRangeDate('lastMonth')} style={dateActive==='lastMonth'?{color:mainColor, fontWeight:"bold"}:null}>지난달</div>
                    <HorizontalRule style={{margin: "0 10px"}}/>
                    <div onClick={() => handleRangeDate('today')} style={dateActive==='today'?{color: mainColor, fontWeight:"bold"}:null}>오늘</div>
                    <HorizontalRule style={{margin: "0 10px"}}/>
                    <div onClick={() => handleRangeDate('lastDay')} style={dateActive==='lastDay'?{color:mainColor, fontWeight:"bold"}:null}>어제</div>
                    <HorizontalRule style={{margin: "0 10px"}}/>
                    <div onClick={() => handleRangeDate('lastWeekDay')} style={dateActive==='lastWeekDay'?{color:mainColor, fontWeight:"bold"}:null}>지난7일</div>
                    <HorizontalRule style={{margin: "0 10px"}}/>
                    <div onClick={() => handleRangeDate('lastThirtyDay')} style={dateActive==='lastThirtyDay'?{color:mainColor, fontWeight:"bold"}:null}>지난30일</div>
                    <HorizontalRule style={{margin: "0 10px"}}/>
                    <div onClick={() => handleRangeDate('lastNinetyDay')} style={dateActive==='lastNinetyDay'?{color:mainColor, fontWeight:"bold"}:null}>지난90일</div>
                  </RangePicker>
                </div>
              </ColSpan2>
              <ColSpan1>
                <GraySearchButton onClick={handleSearchReports}>적용</GraySearchButton>
              </ColSpan1>
              </RowSpan>
              {/*<ValidationGroup>*/}
              {/*  <DefaultButton onClick={handleSearchReports}>검색</DefaultButton>*/}
              {/*</ValidationGroup>*/}
        </BoardSearchDetail>
    </Board>
      <Board>
      <BoardSearchResult>
        <TableDetail
          style={{fontSize: 13, minHeight: adverData?.length !== 0 ? 550 : 300}}
          headerHeight={40}
          lockedRows={lockedReportRows}
          summaryReducer={summaryReportReducer}
          rowExpandHeight={rowExpandHeight}
          data={adverData}
          columns={adverColumn}
          detailData={handleFetchDetailData}
          detailColumn={campaignColumn}
          totalCount={[adverData?.length, '보고서']}
          downloadList={true}
          fileName={'광고주별_보고서'}
          idProperty={'userId'}
        />
      </BoardSearchResult>
    </Board></>
  )
}